var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTop100(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 46,
    viewBox: "0 0 68 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_291_4416)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.95,
    d: "M0 44.8612V20.9375L8.85966 13.8697V44.8604L0 44.8612ZM23.9285 13C16.0912 13 9.73001 20.3332 9.73001 29.3651C9.73084 38.3993 16.092 45.7301 23.9285 45.7301C31.7649 45.7301 38.1261 38.3985 38.1261 29.3651C38.1261 20.3332 31.7649 13 23.9285 13ZM23.9285 37.7558C20.4832 37.7558 17.7193 33.9765 17.7193 29.3283C17.7193 24.6793 20.4832 20.9 23.9285 20.9C27.3737 20.9 30.1376 24.6793 30.1376 29.3275C30.1376 33.9765 27.3737 37.7558 23.9285 37.7558ZM53.2319 13C45.3955 13 39.0351 20.3332 39.0351 29.3651C39.0343 38.3993 45.3947 45.7301 53.2319 45.7301C61.07 45.7301 67.3926 38.3985 67.3926 29.3651C67.3926 20.3332 61.0314 13 53.2319 13ZM53.2319 37.7558C49.7875 37.7558 47.0236 33.9765 47.0236 29.3283C47.0236 24.6793 49.7875 20.9 53.2328 20.9C56.678 20.9 59.4419 24.6793 59.4419 29.3275C59.4419 33.9765 56.6394 37.755 53.2328 37.755L53.2319 37.7558Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.3419 0.603516H21.5393V10.581H24.3419V0.603516ZM6.09245 7.67136L2.98828 10.3172V0.603516H6.09245V7.67136Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.3953 0.603516H22.1861V3.24936H28.3953V0.603516ZM8.85966 0.603516H0V3.02234H8.85966V0.603516Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.6276 0.604299H27.599V10.5818H30.6276V0.604299ZM14.99 0C11.9615 0 9.5 2.45639 9.5 5.47952C9.5 8.50346 11.9615 10.9607 14.99 10.9607C18.0194 10.9607 20.4801 8.50346 20.4801 5.48033C20.4801 2.45639 18.0194 0 14.99 0ZM14.99 8.31482C13.514 8.31482 12.3404 7.02946 12.3404 5.48033C12.3404 3.93039 13.514 2.64585 14.99 2.64585C16.4669 2.64585 17.6405 3.93039 17.6405 5.47952C17.6405 7.02946 16.4669 8.31482 14.99 8.31482Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_291_4416"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 67.3926,
    height: 45.7307,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTop100);
export default __webpack_public_path__ + "static/media/top100.0179e156c8e9381e1bdfe8a56252bdc4.svg";
export { ForwardRef as ReactComponent };